var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarmaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226.92,
    height: 83.08,
    viewBox: "0 0 922 338",
    xmlns: "http://www.w3.org/2000/svg",
    clipRule: "evenodd",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 334,
    id: "svg_47",
    rx: 35,
    ry: 35,
    stroke: "#000000",
    width: 333,
    x: 2,
    y: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169,
    cy: 167,
    fill: "#ffde17",
    id: "svg_51",
    rx: 130,
    ry: 130,
    stroke: "#000000",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffde17",
    height: 163,
    id: "svg_46",
    rx: 35,
    ry: 35,
    stroke: "#000000",
    width: 572,
    x: 348,
    y: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 163,
    id: "svg_48",
    rx: 35,
    ry: 35,
    stroke: "#000000",
    width: 572,
    x: 348,
    y: 173
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 41,
    id: "svg_50",
    stroke: "#000000",
    transform: "matrix(1 0 0 1 0 0)",
    width: 41,
    x: 64,
    y: 123
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 41,
    id: "svg_52",
    stroke: "#000000",
    transform: "matrix(1 0 0 1 0 0)",
    width: 41,
    x: 106,
    y: 173
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 41,
    id: "svg_53",
    stroke: "#000000",
    transform: "matrix(1 0 0 1 0 0)",
    width: 41,
    x: 149,
    y: 123
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 41,
    id: "svg_54",
    stroke: "#000000",
    transform: "matrix(1 0 0 1 0 0)",
    width: 41,
    x: 192,
    y: 173
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 41,
    id: "svg_56",
    stroke: "#000000",
    transform: "matrix(1 0 0 1 0 0)",
    width: 41,
    x: 234,
    y: 123
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Sans-serif",
    fontSize: 125,
    fontWeight: "bold",
    id: "svg_57",
    letterSpacing: 10,
    stroke: "#000000",
    strokeWidth: 0,
    textAnchor: "middle",
    x: 628,
    xmlSpace: "preserve",
    y: 126
  }, "699"), /*#__PURE__*/React.createElement("text", {
    fill: "#ffde17",
    fontFamily: "Sans-serif",
    fontSize: 125,
    fontWeight: "bold",
    id: "svg_58",
    letterSpacing: 10,
    stroke: "#000000",
    strokeWidth: 0,
    textAnchor: "middle",
    transform: "matrix(1 0 0 1 0 0)",
    x: 625,
    xmlSpace: "preserve",
    y: 297
  }, "TAXI"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarmaLogo);
export default __webpack_public_path__ + "static/media/CarmaLogo.9e85c138083382b28e0d29e35d3f5e43.svg";
export { ForwardRef as ReactComponent };